import React from 'react'
import Slide7Img from "./slideimg/slide7.png"
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const Slide7 = () => {

  const slide7Style = css`
    width: 60vw;
    box-shadow: 5px 5px 20px 5px #123456;
    border-radius:25px;
  `;

  return (
    <div>
      <img src={Slide7Img} css={slide7Style}></img>
      <p>
        全ての単語を集めたらハニカムが画面に表示されます。<br></br>
        ハニカム構造に当てはめることができると正解です。
      </p>
    </div>
  )
}

export default Slide7
